module.exports = __webpack_public_path__ + "static/media/pilot_1_big.b97060f6.png";